import { render, staticRenderFns } from "./DeleteList.vue?vue&type=template&id=33244efa&scoped=true&"
import script from "./DeleteList.vue?vue&type=script&lang=js&"
export * from "./DeleteList.vue?vue&type=script&lang=js&"
import style0 from "./DeleteList.vue?vue&type=style&index=0&id=33244efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33244efa",
  null
  
)

export default component.exports